module.exports = __webpack_public_path__ + "img/923949-88-6.bdd8ed32.png";